export const apiName: string = 'categorias';
export const categoriasRoute: string = 'categorias';
export const categoriasStorage: string = 'categorias';
export const categoriasModuleName: any = {plural: 'Categorias', single: 'Categoria'};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/categorias/shared/data.service.ts
 **/